import React from 'react';
import PropTypes from 'prop-types';

import { SortableElement } from 'react-sortable-hoc';
import DragHandle from '../../../../common/ui/DragHandle';

import { getTravelType } from '../TravelTypes';
import Address from '../../../../common/ui/Address';

const TravelItem = SortableElement(({ travel, onEdit, onDelete }) => {
  const noPropagate = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  const travelType = getTravelType(travel.type);
  return (
    <li className="sortable-item editable-entity" onClick={() => onEdit(travel)}>
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-8">
        <span className="type">{travelType}</span>
        <span className="title-v2">{travel.name}</span>
        <Address
          address1={travel.address_1}
          address2={travel.address2}
          city={travel.city}
          state={travel.state_province}
          zip={travel.postal_code}
          countryCode={travel.country_code}
          singleLine
        />
        {travel.code && (
          <span className="description text-primary">Discount Code - {travel.code}</span>
        )}
        {travel.note && <span className="description">{travel.note}</span>}
      </div>
      <div className="col-sm-3 entity-actions" onClick={noPropagate}>
        <button
          onClick={() => onEdit(travel)}
          title="Edit"
          className="btn btn-icon with-tooltip no-tooltip-on-mobile"
          data-tooltip="Edit"
        >
          <i className="glyphicon glyphicon-pencil" />
        </button>
        <button
          onClick={() => onDelete(travel)}
          title="Delete"
          className="btn btn-icon with-tooltip no-tooltip-on-mobile"
          data-tooltip="Delete"
        >
          <i className="glyphicon glyphicon-trash" />
        </button>
      </div>
    </li>
  );
});

TravelItem.propTypes = {
  travel: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number,
};

export default TravelItem;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Travel/TravelItem.jsx